import { Hotkey } from '../types/Hotkey.ts';

export const HOTKEY_LABELS = {
    [Hotkey.Up]: 'Scroll/Move Up',
    [Hotkey.Down]: 'Scroll/Move Down',
    [Hotkey.Left]: 'Scroll/Move Left',
    [Hotkey.Right]: 'Scroll/Move Right',
    [Hotkey.ActionX1]: 'Run',
    [Hotkey.ActionX2]: 'Reset',
    [Hotkey.ActionX3]: 'Hide app',
    [Hotkey.ActionX4]: 'Dynamic variable toggle',
    [Hotkey.ActionX5]: 'Selected profile toggle',
    [Hotkey.ActionY1]: 'Quit app',
    [Hotkey.MoveAppUp]: 'Move app up',
    [Hotkey.MoveAppDown]: 'Move app down',
    [Hotkey.MoveAppLeft]: 'Move app left',
    [Hotkey.MoveAppRight]: 'Move app right',
};
